export const COLORS = {
  FINISHED_ITEM: '#198754',
  FINISHED_PRODUCT: '#f9717e',
  ACTIVE_ITEM: '#b6d4fe',
};
